import { Truck } from "lucide-react";
import { useI18n } from "../../../i18n";
import { fmtDate, fmtTime, fmtWeekday } from "../../../lib/format";

export const DeliveryPicker = ({ delivery, value, onChange }) => {
  const { t, lang } = useI18n();
  if (delivery.isLoading) return <div className="h-24 animate-pulse rounded-2xl bg-slate-200/70" />;
  const slots = delivery.data?.slots || [];
  if (!slots.length) return <p className="rounded-xl bg-amber-50 px-3 py-2 text-sm text-amber-800" data-testid="no-delivery-slots">{t("checkout.noSlots")}</p>;
  return (
    <div>
      <p className="mb-2 flex items-center gap-1.5 text-xs text-slate-500"><Truck className="h-3.5 w-3.5" /> {t("home.area", { area: delivery.data.area[`name_${lang}`] })}</p>
      <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1 [scrollbar-width:none]" data-testid="delivery-slots">
        {slots.slice(0, 8).map((s) => {
          const on = s.date === value;
          return (
            <button key={s.date} type="button" onClick={() => onChange(s.date)} data-testid={`delivery-slot-${s.date}`}
              className={`flex min-w-[112px] shrink-0 flex-col items-start rounded-2xl border-2 px-3 py-2.5 text-left transition-colors duration-150 ${on ? "border-brand bg-brand/10" : "border-slate-200 bg-white hover:border-slate-300"}`}>
              <span className="text-sm font-semibold capitalize text-navy">{fmtWeekday(s.date, lang)}</span>
              <span className="text-xs tabular-nums text-slate-600">{fmtDate(s.date)}</span>
              <span className="mt-1 text-[11px] text-slate-500">{t("checkout.orderBy", { day: fmtWeekday(s.order_by, lang, "short"), time: fmtTime(s.order_by) })}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
